import React from 'react';
import cn from 'classname';
import './index.less';

function PayoutAction({ column, processing, children }) {
	return (
		<div className={cn(`payout-table--body--action-${column}`, {
			'payout-table--body--action-processing': processing
		})}>
			{children}
		</div>
	);
}

export default PayoutAction;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payouts/components/table/components/payout-body/components/payout-action/index.js